import React, { useEffect, useState } from "react";

function AppBalanceBar() {
  const [visible, setVisible] = useState(false);
  const [balance, setBalance] = useState(0);
  const [dots, setDots] = useState("");

  // ✅ Detect Android WebView safely (even if injected late)
  useEffect(() => {
    let attempts = 0;

    const checkAndroid = setInterval(() => {
      if (window.IS_ANDROID_APP === true) {
        setVisible(true);
        clearInterval(checkAndroid);
      }

      attempts++;
      if (attempts > 20) clearInterval(checkAndroid);
    }, 150);

    // Android can call this anytime
    window.updateBalance = (newBalance) => {
      setBalance(Number(newBalance));
    };

    return () => clearInterval(checkAndroid);
  }, []);

  // Loading dots animation
  useEffect(() => {
    if (balance !== 0) return;

    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 500);

    return () => clearInterval(interval);
  }, [balance]);

  if (!visible) return null;

  return (
    <header
      style={{
        backgroundImage: "linear-gradient(#2e506c,#152337)",
        padding: "6px 12px",
        position: "sticky",
        top: 0,
        zIndex: 9999,
      }}
    >
      <div
        className="container d-flex justify-content-between align-items-center"
        style={{ minHeight: "35px" }}
      >
        <a
          href="https://betprowallet.pk"
          className="text-white text-decoration-none"
          style={{ fontWeight: 500 }}
        >
          Betpro Plus
        </a>

        <span className="text-white" style={{ fontWeight: 700 }}>
          B: {balance === 0 ? dots || "." : balance}
        </span>
      </div>
    </header>
  );
}

export default AppBalanceBar;
